import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AclActionDirective, AclActionParentDirective } from '@app/acl/directives/acl-action.directive';
import { AclComponentDirective } from '@app/acl/directives/acl-component.directive';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    AclActionDirective,
    AclActionParentDirective,
    AclComponentDirective
  ],
  exports: [
    AclActionDirective,
    AclActionParentDirective,
    AclComponentDirective
  ]
})
export class AclModule {
}
